export default "__VITE_ASSET__348dd527__"